import { useEffect, useMemo } from "react";
import { formatIndianNumber } from "../../_helpers/formatUtils";
import { groupSSRBySegment } from "../../_helpers/ssrUtils";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setPassangerMealIndex } from "./reviewbookingSlice";

const MealSelection = ({
  flightReviewDetails,
  travellers,
  selectedmealPerSegment,
  toggleMealSelection,
}: {
  flightReviewDetails: any;
  travellers: any[];
  selectedmealPerSegment: {
    [segmentIndex: number]: { [passengerIndex: number]: any };
  };
  toggleMealSelection: (
    ssr: any,
    passengerIndex: number,
    segmentIndex: number
  ) => void;
}) => {
  const dispatch = useAppDispatch();
  const passangerMealIndex = useAppSelector(
    (state) => state.reviewbooking.passangerMealIndex
  );

  const routewiseSegmentArray = flightReviewDetails.flatMap(
    (e: any) => e.Flight?.Segments
  );

  const ssrData = useAppSelector((state) => state.reviewbooking.ssrData);

  const segmentWiseSSR = groupSSRBySegment(ssrData);

  return (
    <>
      <div className="seat-slection-title ssr-slection-title">
        <h4 className="m-0 passanger-tabs">
          {travellers.map((traveller, i) => {
            const mealCount = Object.keys(
              selectedmealPerSegment?.[i] || {}
            ).length;

            const totalMealAmount = Object.values(
              selectedmealPerSegment?.[i] || {}
            ).reduce(
              (acc: number, ssr: any) => acc + (ssr?.Total_Amount || 0),
              0
            );

            return (
              <span
                className={`title-passanger-name ${
                  i === passangerMealIndex ? "active" : ""
                }`}
                onClick={() => dispatch(setPassangerMealIndex(i))}
              >
                {`${traveller?.initial} ${traveller?.first_name}  ${
                  traveller?.last_name
                }(${mealCount} Meal - ₹ ${formatIndianNumber(
                  totalMealAmount
                )})`}
              </span>
            );
          })}
        </h4>
      </div>
      {travellers.map((traveller, passengerIndex) => {
        if (passengerIndex !== passangerMealIndex) return null;

        return (
          <Swiper
            key={passengerIndex}
            slidesPerView="auto"
            spaceBetween={30}
            pagination={{ clickable: true }}
            navigation
            modules={[Navigation]}
            allowTouchMove={false}
            className="ssr-slider"
          >
            {segmentWiseSSR?.map((ssrDetails: any, segmentIndex: number) => {
              const totalSegment = segmentWiseSSR?.length;

              const selectedMeal =
                selectedmealPerSegment?.[passengerIndex]?.[segmentIndex];
              const mealAmount = selectedMeal?.Total_Amount || 0;

              const mealArray = ssrDetails?.SSRDetails?.filter(
                (e: any) => e?.SSR_Type === 1 || e?.SSR_Type === 2
              );

              return (
                <SwiperSlide
                  key={segmentIndex}
                  className={totalSegment === 1 ? "one-slide" : "multi-slide"}
                >
                  <div
                    className="w-100"
                    style={{
                      backgroundColor: "white",
                      boxShadow: "0 0 5px #00000026",
                      borderRadius: "5px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      className="p-2 w-100"
                      style={{ borderBottom: "1px solid lightgray" }}
                    >
                      <div className="route-seat-selection-title">
                        <h4 className="m-0">
                          {routewiseSegmentArray[segmentIndex]?.Origin_City} →{" "}
                          {
                            routewiseSegmentArray[segmentIndex]
                              ?.Destination_City
                          }
                        </h4>
                        <span
                          className={`m-0 ${
                            !selectedMeal ? "pending-selection" : "seat-amount"
                          }`}
                        >
                          {!selectedMeal
                            ? "Selection pending"
                            : "₹ " + formatIndianNumber(mealAmount)}
                        </span>
                      </div>
                      <div className="route-seat-selection-title">
                        <span className="m-0">
                          {selectedMeal ? "1" : "No"} Meal Selected
                        </span>
                        {selectedMeal && (
                          <span className="m-0">Added to fare</span>
                        )}
                      </div>
                    </div>

                    <div className="position-relative">
                      <div className="grid grid-cols-12 main-ssrselection-layout">
                        <div className="space-y-2 col-span-12">
                          {mealArray?.length > 0 ? (
                            mealArray?.map((ssr: any) => {
                              const isSelected =
                                selectedMeal?.SSR_Key === ssr.SSR_Key;

                              return (
                                <div
                                  className="flight-card mb-4"
                                  key={ssr.SSR_Key}
                                >
                                  <div className="flight-info">
                                    <h3 className="flight-title">
                                      {/* {ssr.SSR_TypeName} */}
                                      {ssr.SSR_TypeDesc}
                                    </h3>
                                    {/* <p className="flight-description">
                                      {ssr.SSR_TypeDesc}
                                    </p> */}
                                    <span className="ssr-price">
                                      ₹ {formatIndianNumber(ssr.Total_Amount)}
                                    </span>
                                  </div>

                                  <button
                                    type="button"
                                    className={`flight-select-btn ${
                                      isSelected ? "selected" : ""
                                    }`}
                                    onClick={() =>
                                      toggleMealSelection(
                                        ssr,
                                        passengerIndex,
                                        segmentIndex
                                      )
                                    }
                                  >
                                    {isSelected ? "Selected" : "Select"}
                                  </button>
                                </div>
                              );
                            })
                          ) : (
                            <h4 className="text-center">
                              Meal selection is unavailable for this segment
                            </h4>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        );
      })}
    </>
  );
};

export default MealSelection;
